import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Menu from "./pages/Menu";
import OrderForm from "./pages/OrderForm";
import Success from "./pages/Success";
import "../style/navigation.css";
import ViewMenu from "./pages/View-Menu";
import ItemDetails from "./pages/ItemDetails";
import { ReactComponent as Logo } from "../logo/KGLOGOFINAL-1.svg";

// Scroll to top when route changes
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [menuActive, setMenuActive] = useState(false);

  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  const closeMenu = () => {
    setMenuActive(false);
  };

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (menuActive) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [menuActive]);

  return (
    <Router>
      <nav className='navbar'>
        <div className='navbar-container'>
          {/* Logo */}
          <Link to="/" className='navbar-logo' onClick={closeMenu}>
            <Logo className='logo'/>
          </Link>

          {/* Desktop Menu */}
          <ul className='navbar-menu'>
            <li>
              <Link to='/' className='navbar-link'>Home</Link>
            </li>
            <li>
              <Link to='/about' className='navbar-link'>About</Link>
            </li>
            <li>
              <Link to='/view-menu' className='navbar-link'>View Menu</Link>
            </li>
            <li>
              <Link to='/menu' className='navbar-link navbar-link-order'>Order Online</Link>
            </li>
            <li>
              <Link to='/order' className='navbar-link navbar-link-cart'>Cart</Link>
            </li>
          </ul>

          {/* Mobile Hamburger */}
          <button
            className={`navbar-hamburger ${menuActive ? "active" : ""}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        {/* Mobile Menu Overlay */}
        <div 
          className={`navbar-overlay ${menuActive ? "active" : ""}`}
          onClick={closeMenu}
        ></div>

        {/* Mobile Menu */}
        <div className={`navbar-mobile ${menuActive ? "active" : ""}`}>
          <ul className='navbar-mobile-menu'>
            <li>
              <Link to='/' className='navbar-mobile-link' onClick={closeMenu}>
                Home
              </Link>
            </li>
            <li>
              <Link to='/about' className='navbar-mobile-link' onClick={closeMenu}>
                About
              </Link>
            </li>
            <li>
              <Link to='/view-menu' className='navbar-mobile-link' onClick={closeMenu}>
                View Menu
              </Link>
            </li>
            <li>
              <Link to='/menu' className='navbar-mobile-link' onClick={closeMenu}>
                Order Online
              </Link>
            </li>
            <li>
              <Link to='/order' className='navbar-mobile-link navbar-mobile-link-cart' onClick={closeMenu}>
                Cart
              </Link>
            </li>
          </ul>
        </div>
      </nav>

      <ScrollToTop />
      <Routes>
        <Route exact path='/' element={<Home />}></Route>
        <Route path='/about' element={<About />}></Route>
        <Route path='/menu' element={<Menu />}></Route>
        <Route path='/order' element={<OrderForm />}></Route>
        <Route path='/success' element={<Success />}></Route>
        <Route path='/view-menu' element={<ViewMenu />}></Route>
        <Route path='/item/:id' element={<ItemDetails />}></Route>
      </Routes>
    </Router>
  );
}

export default App;
